module.exports = __webpack_public_path__ + "static/Football and Hockey Ground-5d978bb94e1040307dc28fdcdbf56cd9.jpeg";